import type { Prototype } from "../prototype-types";

export const shengchaoWangPrototypes: Prototype[] = [
  {
    id: "sw-canada-clawback-instrument-link",
    name: "Canada Clawback Instrument Link",
    path: "/sw/canada-clawback-instrument-link",
    description: "New Canada brand designating a clawback payment method — two entry points: the first-order payout flow (4 steps to 5) and the post-Stripe-onboarding settings prompt.",
    owner: "Shengchao Wang",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
      thumbnail: "/images/thumbnails/sw-canada-clawback-instrument-link.png"
},
];
